import { Link } from "react-router-dom";
import Label from "../../../Label";
import Button from "../../../Button";

const PrimaryCardButton = ({ label, link = null, icon }) => {
  return (
    <Link to={link ? link : ""}>
      <div className="primary-card-button md:w-[51px] md:h-[74px] w-[38px] h-[60px] flex-col justify-center items-center gap-2 inline-flex">
        <Button
          className="btn flex justify-center items-center md:w-[42px] w-[34px] py-[6px] md:py-[9px] px-4"
          icon={icon}
        />
        <Label className="label" text={label} />
      </div>
    </Link>
  );
};
export default PrimaryCardButton;
